import React from "react";
import type { FC, JSX, PropsWithChildren } from "react";

import { createDisplayNameForUniCardElement } from "../../utils/getDisplayName";
import { createTestIdForUniCardElement } from "../../utils/getTestId";

import classes from "./UniCardText.styl";

const UNI_CARD_TEXT_TEST_ID = createTestIdForUniCardElement("text");

interface IText extends PropsWithChildren {}

export const UniCardText: FC<IText> = ({ children }): JSX.Element => {
    return (
        <div className={classes["text"]} data-tsid={UNI_CARD_TEXT_TEST_ID}>
            {children}
        </div>
    );
};

UniCardText.displayName = createDisplayNameForUniCardElement("Text");

export default UniCardText;
